<mat-card class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >Equipment Standard List</mat-card-title
    >
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-location-type-filter
          [standardFiltration]="standardFiltrationForChipSet"
          [standardListType]="standardListType.GlobalEquipment"
          (messageEvent)="receivedFilteration($event)"
        ></app-location-type-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="!loading">
      <div class="row">
        <div class="col-md-12 float-left">
          <div class="float-left">
            <mat-form-field>
              <input
                matInput
                placeholder="Search by Title, Model or Description"
                value="{{ searchKey }}"
                (keyup.enter)="addSearchKey(key)"
                name="search"
                #key
              />
              <button
                mat-button
                *ngIf="searchKey"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchKey = ''; addSearchKey(searchKey)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="standards.length > 0" class="col-md-12">
          <!-- <div>
            <div class="row">
              <div class="col-md-3 col-sm-6 list-card-wrapper" *ngFor="let item of standards">
                <div class="card mcd-equipment-card">
                  <img class="card-img-top" [src]="item?.equipmentStandard.imageAttachment?.image" alt="Card image cap">
                  <div class="card-body">
                    <div class="card-body-inner">
                      <h5 class="card-title">{{item.title}}</h5>
                      <p class="card-text">{{item.equipmentStandard.model}}</p>
                      <p class="card-text">{{item.equipmentStandard.equipmentType.name}}</p>
                      <p class="card-text">{{item.locationType.name}}</p>
                      <p class="card-text">Effective Date - {{item.obj.equipmentStandard | date: 'MM.dd.yyyy' }}</p>
                      <div class="footer-item">
                        <div class="row">
                          <div class="col">
                          </div>
                          <div class="col text-right more-link-view">
                            <a [routerLink]="'/view-equipments-standard-detail/' + item.id" href="javascript:void(0)">
                              More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button title="edit" *ngIf="canEditEquipmentStandard" class="btn-edit mat-icon-button" (click)="onEdit(item.id)">
                    <i class="material-icons"> edit</i>
                  </button>
                 <button title="delete" *ngIf="canDeleteEquipmentStandard" class="btn-delete mat-icon-button" (click)="openDeletePopup(item)">
                   <i class="material-icons">clear</i>
                  </button>
                </div>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-6">
              <mat-form-field>
                <mat-select
                  [value]="pageSize"
                  name="nOfRows"
                  #items
                  (selectionChange)="selectedItemsPerPageChange(items)"
                >
                  <mat-option
                    [value]="item.value"
                    *ngFor="let item of pageSizes"
                  >
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-6 float-right">
              <!-- <button disabled> -->
              <a
                *ngIf="standards.length > 0 && isDownloading"
                class="float-right"
                disabled
              >
                Downloading, Please wait...
                <svg
                  class="fontawesomesvg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                >
                  <!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
                  <path
                    d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
                  />
                </svg>
              </a>
              <a
                *ngIf="standards.length > 0 && !isDownloading"
                class="float-right"
                href="javascript:void(0);"
                (click)="downloadExcel()"
                style="
                  margin-top: 10px;
                  color: #0b59ca;
                  text-decoration: none;
                  cursor: pointer;
                  font-weight: bold;
                "
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-bottom: 2px; margin-right: 2px"
                >
                  <path
                    d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Download All
              </a>
              <!-- </button> -->
            </div>
          </div>
          <table
            matSort
            (matSortChange)="sortData($event)"
            class="table nrbes-grid"
          >
            <thead class="thead-light">
              <tr>
                <th mat-sort-header="equipmentType" width="110" scope="col-2">
                  Equipment Type
                </th>
                <th mat-sort-header="supplier" width="110" scope="col-2">
                  Supplier
                </th>
                <th mat-sort-header="title" scope="col-4" width="20%">Title</th>
                <th mat-sort-header="model" scope="col" width="110">Model</th>
                <th mat-sort-header="equipmentClass" scope="col" width="110">
                  Equipment Class
                </th>
                <th scope="col-4" width="10%">Location Type</th>
                <th scope="col-4" width="15%">Obsolete Date</th>
                <th scope="col" width="80" *ngIf="canEditEquipmentStandard">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of standards" (click)="rowSelected(item)">
                <td class="description" style="font-weight: bold;">
                  {{ item.equipmentStandard.equipmentType.name }}
                </td>
                <td class="description">
                  {{ item.equipmentStandard.supplier.name }}
                </td>
                <td class="title-cell">{{ item.title }}</td>
                <td class="description">{{ item.equipmentStandard.model }}</td>
                <td class="description">
                  {{ item.equipmentStandard.equipmentClassType.name }}
                </td>
                <td class="location-cell">{{ getLocationNames(item) }}</td>
                <td
                  class="category-cell"
                  *ngIf="
                    item?.equipmentStandard?.obsoleteDate != null;
                    else elseBlock
                  "
                >
                  Obsolete Date -
                  {{
                    item.equipmentStandard.obsoleteDate | date : "MM.dd.yyyy"
                  }}
                </td>
                <ng-template #elseBlock>
                  <td class="category-cell">
                    Obsolete Date Not Set
                  </td></ng-template
                >

                <td *ngIf="canEditEquipmentStandard">
                  <div class="row grid-actions hide-sm">
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="openDeletePopup(item, $event)"
                        routerLinkActive="active"
                        title="clear"
                        ><i class="material-icons"> clear </i></a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="onEdit(item.id)"
                        routerLinkActive="active"
                        title="Edit"
                        href="javascript:void(0);"
                        ><i class="material-icons"> create </i></a
                      >
                    </div>
                  </div>

                  <a
                    (click)="actionMenuOpen($event)"
                    class="mcd-more-btn show-sm"
                    [matMenuTriggerFor]="menu"
                    href="javascript:void(0);"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>
                  <mat-menu #menu="matMenu" overlapTrigger="false">
                    <span>
                      <button mat-menu-item (click)="onEdit(item.id)">
                        Edit
                      </button>
                      <button
                        mat-menu-item
                        (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                      >
                        Remove
                      </button>
                    </span>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *ngIf="standards.length > 0">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getAllEquipmentStandards()"
          >
          </ngb-pagination>
        </div>
      </div>
      <div class="row">
        <div *ngIf="standards.length == 0 && !searchKey" class="col-md-9">
          Sorry you do not have any equipment standard.
        </div>
        <div *ngIf="standards.length == 0 && searchKey">
          No results found based on search terms.&nbsp;&nbsp;<a
            href="javascript:void(0);"
            (click)="addSearchKey(''); getStandards()"
          >
            <span> Go Back </span>
          </a>
        </div>
      </div>
    </div>
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>
